import React from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import { usePolicyPlanTemplateContext } from 'contexts/PolicyPlanTemplateContext';

export default function Actions({ row, setTypeView }) {
  const { dispatch, actions, state } = usePolicyPlanTemplateContext();

  const editTemplate = (e, row) => {
    actions.edit(dispatch, row);
    setTypeView('edit');
  };

  const deleteTemplate = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this template?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.delete(dispatch, row);
        }
      },
    );
  };

  return (
    <div>
      <a onClick={(e) => editTemplate(e, row)} className="mr10">
        <img src={editIcon} />
      </a>
      {row.attributes.id != '0' && (
        <a onClick={(e) => deleteTemplate(e, row)}>
          <img src={deleteIcon} />
        </a>
      )}
    </div>
  );
}
